<template>
    <div class="full-content" v-show="isTokenValid">
        <v-navigation-drawer
            v-model="drawer"
            :temporary="false"
            :permanent="$vuetify.breakpoint.mdAndUp"
            app
        >
            <v-list>
                <v-list-item class="px-2 flex-row justify-center">
                    <v-list-item-avatar height="75" width="75">
                        <avatar :username="jwtData.username || 'kullanici'" :size="75"/>
                    </v-list-item-avatar>
                </v-list-item>

                <v-list-item link>
                    <v-list-item-content>
                        <v-list-item-title class="title">
                            <v-icon color="green">mdi-account-circle</v-icon>
                            {{jwtData.username}}
                        </v-list-item-title>
                        <v-list-item-subtitle v-if="false">
                            {{jwtData.username}}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list
                nav
                dense
            >
                <v-list-item
                    v-for="item in menuItems"
                    :key="item.label"
                    link
                    :to="item.to">
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-left">{{ item.label }}</v-list-item-title>
                </v-list-item>
            </v-list>

            <template v-slot:append>
                <div class="pa-2">
                    <v-btn block @click="logout">
                        <v-icon>mdi-power</v-icon>
                        Cikis
                    </v-btn>
                </div>
            </template>
        </v-navigation-drawer>

        <v-system-bar color="deep-purple darken-3"></v-system-bar>

        <v-app-bar
            color="deep-purple accent-4"
            dark
            app
        >
            <v-app-bar-nav-icon
                v-if="$vuetify.breakpoint.smAndDown"
                @click.stop="drawer = !drawer"
            />

            <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon v-if="false">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>

            <v-btn icon v-if="false">
                <v-icon>mdi-filter</v-icon>
            </v-btn>



            <v-menu v-if="shortLinks.length" rounded="sm">
                <template v-slot:activator="{ attrs, on }">
                    <v-btn icon v-on="on" v-bind="attrs">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>

                <v-list dense nav>
                    <v-list-item
                        v-for="link in shortLinks"
                        :key="link.label"
                        link
                        :to="link.to"
                    >
                        {{ link.label }}
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>

        <!-- Sizes your content based upon application components -->
        <v-main>

            <!-- Provides the application the proper gutter -->
            <v-container class="mak-app-container" fluid>

                <!-- If using vue-router -->
                <slot></slot>
            </v-container>
        </v-main>

        <v-footer class="px-0 py-0" app>
            <!-- -->
        </v-footer>
    </div>
</template>

<script>
    import Vuex from 'vuex';
    import Avatar from 'vue-avatar';

    export default {
        name: 'default-layout',
        components: { Avatar },
        data() {
            return {
                drawer: false,
            };
        },
        computed: {
            ...Vuex.mapState(['pageLinks']),
            ...Vuex.mapGetters(['jwtData', 'isAdmin', 'isTokenValid']),
            shortLinks() {
                return this.pageLinks[this.$route.name] || [];
            },
            menuItems() {
                const adminRoutes = [
                    {
                        to: { name: 'kontrol-planlama' },
                        label: 'Kontrol Planlama',
                        icon: 'mdi-application-cog',
                    },
                    {
                        to: { name: 'fatura' },
                        label: 'Fatura Bilgileri',
                        icon: 'mdi-receipt',
                    },
                    {
                        to: { name: 'makina' },
                        label: 'Makina Bilgileri',
                        icon: 'mdi-developer-board',
                    },
                    {
                        to: { name: 'koku' },
                        label: 'Koku Bilgileri',
                        icon: 'mdi-lipstick',
                    },
                    // {
                    //     to: { name: 'kullanici' },
                    //     label: 'Kullanıcı Bilgileri',
                    //     icon: 'mdi-account-group-outline',
                    // },
                ]
                return [
                    {
                        to: { name: 'kontrol-paneli' },
                        label: 'Kontrol Paneli',
                        icon: 'mdi-home',
                    },
                    {
                        to: { name: 'kontroller' },
                        label: 'Kontroller',
                        icon: 'mdi-format-list-checks',
                    },
                    {
                        to: { name: 'gunluk-kontroller' },
                        label: 'Günlük Kontroller',
                        icon: 'mdi-format-list-checks',
                    },
                    {
                        to: { name: 'musteri' },
                        label: 'Müşteriler',
                        icon: 'mdi-account-group',
                    },
                    {
                        to: { name: 'gider-yonetimi' },
                        label: 'Gider Yönetimi',
                        icon: 'mdi-cash',
                    },
                    ...(this.isAdmin ? adminRoutes : []),
                ];
            },
        },
        methods: {
            ...Vuex.mapActions(['clearJWT']),
            logout() {
                this.clearJWT();
                this.$router.push({ name: 'giris' });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .mak-app-container {
        padding-bottom: 4rem;
    }
</style>
